var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("TabelToolBar", {
            ref: "TabelToolBar",
            on: {
              onHandlePrint: _vm.onHandlePrint,
              onHandleAuditOrder: _vm.onHandleAuditOrder,
              onUnCheckBillOrder: _vm.onUnCheckBillOrder,
              onCancelBillOrder: _vm.onCancelBillOrder,
              nextOrder: _vm.nextOrder,
              getBackOrder: _vm.getBackOrder,
              onSaveEditOrder: _vm.onSaveEditOrder,
              onBeforeShowAddRowDialogForaddOrder:
                _vm.onBeforeShowAddRowDialogForaddOrder,
              onClickEditOrder: _vm.onClickEditOrder,
              onHandleExportDetailData: _vm.onHandleExportDetailData,
              onClickaddOrder: _vm.onClickaddOrder,
              onBeforeShowAddRowDialogForEditOrder:
                _vm.onBeforeShowAddRowDialogForEditOrder,
              onBeforSaveAddOrder: _vm.onBeforSaveAddOrder,
              onSendMail: _vm.onSendMail,
              onHandleCancel: _vm.onHandleCancel
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "Outsourced-Edit" },
        [
          _vm.isShowTabelHeaderForNewOrder
            ? _c("TabelHeaderForNewOrder", {
                ref: "TabelHeaderForNewOrder",
                on: {
                  onShowAddRowDialogForAdd: _vm.onShowAddRowDialogForAdd,
                  onSaveAddOrderForAdd: _vm.onSaveAddOrderForAdd
                }
              })
            : _vm._e(),
          _vm.isShowTabelHeaderForEdit
            ? _c("TabelHeaderForEdit", {
                ref: "TabelHeaderForEdit",
                on: {
                  onBeforeSaveEditOrder: _vm.onBeforeSaveEditOrder,
                  cbVENDOR_CODE: _vm.cbVENDOR_CODE,
                  cbNextOrder: _vm.cbNextOrder
                }
              })
            : _vm._e(),
          _c("EditTable", {
            ref: "EditTable",
            on: {
              upDateTableBar: _vm.upDateTableBar,
              onUpdataOrderStaus: _vm.onUpdataOrderStaus,
              onSuccessSave: _vm.onSuccessSave,
              cbCreateOrderSuccess: _vm.cbCreateOrderSuccess
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }